import path from 'path';

export function removeExtention(fileName: string) {
  const extension = path.extname(fileName);
  return fileName.replace(extension, '');
}
